<template>
  <div class="tab-body">

    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData" stripe border height="auto" v-loading="listLoading">
        <el-table-column prop="name" width="260" label="作业名称"> <template slot-scope="scope">
            <span :title="scope.row.name">{{ scope.row.dbColumn_expid }}</span>
          </template></el-table-column>
        <el-table-column label="章节" prop="sbname" width="200px">
        </el-table-column>
        <el-table-column prop="type" width="100" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.answer" type="success" size="mini"> 已交 </el-tag>
            <el-tag v-else type="warning" size="mini"> 未完成 </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="score" width="100" label="作业总分">
          <template slot-scope="scope">
            {{ scope.row.exscores }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="开始-截止时间">
          <template slot-scope="scope">
            <el-tag size="mini" type="success">
              {{ scope.row.startTime }}</el-tag>
            <el-tag size="mini" type="danger"> {{ scope.row.endTime }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button size="mini" @click="toStartTest(scope.$index, scope.row)">
                {{ scope.row.anscore>0?'查看答案':(scope.row.answer?'修改作业':'完成作业')  }}
                </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
          :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>
    <startTest ref="startTest" @closeExam="closeExam"></startTest>
    <dohk ref="dohk" @closeExam="closeExam"></dohk>
  </div>
</template>
<script>
import startTest from "./startTest.vue";
import dohk from "./dohk.vue";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import api from "@/api/exams/exams/exams.js";

export default {
  name: "exams",

  components: {
    startTest,
    selectOptionDictionary,
    dohk
},
  data() {
    return {
      name: "",
      extype: "",
      searchParams: { type: 1 },
      isShowMoreSearch: false,
      listLoading: false,
      stuid: '',
      listData: [],
      selected: [],
      page: new this.$constant.pageObj(),
    };
  },
  watch: {
    "searchParams.name": function () {
      this.search();
    },
  },

  methods: {
    //去考试
    toStartTest(index, row) {
      if ( row.anscore>0) {
          this.$refs.dohk.open(row.id, this.stuid, "作业答案 - " + row.name);
      } else {
          this.$refs.startTest.open(row, "完成作业 - " + row.name);   
      }
    },

    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page, { isHK: 3 });
      api.list(params, (response) => {
        
        this.listData = response.data.records;
        this.listLoading = false;
      });
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //搜索
    search() {
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = { type: 1 };
      this.list();
    },
    closeExam() {
      this.list();

    },
  },
  mounted() {
    this.list();
    let me = this.$caches.user.get();
      this.stuid = me.id;
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";

.el-tag {
  margin: 0 5px;
}
</style>
